import type { StructuraSessionRole } from "./session-types";

export type WorkspaceTenantUser = {
  role?: StructuraSessionRole | null;
  tenantId?: string | null;
};

export type ResolveWorkspaceTenantOptions = {
  superAdminInApp: boolean;
  storedTenantId: string | null;
};

/** Perfil de resolución: FM (simple) vs BH (fallback stored para no-owner). */
export type WorkspaceTenantProfile = "fm" | "bh";

/**
 * Tenant activo en /app: impersonación super_admin tiene prioridad cuando aplica.
 */
export function resolveWorkspaceTenantId(
  user: WorkspaceTenantUser,
  opts: ResolveWorkspaceTenantOptions,
  profile: WorkspaceTenantProfile = "fm",
): string | null {
  if (user.role === "super_admin" && opts.superAdminInApp && opts.storedTenantId) {
    return opts.storedTenantId;
  }
  if (user.tenantId) return user.tenantId;

  if (profile === "bh") {
    if (user.role === "owner") return null;
    return opts.storedTenantId;
  }

  // FM: staff sin tenantId en JWT puede usar workspace almacenado
  if (user.role === "staff" && opts.storedTenantId) return opts.storedTenantId;
  return null;
}
